<template>
  <div class="floor">
    <div class="titleArea" v-if="dataSource.showTopFloor">
      <img :src="titleLineImg" />
      <div class="title" :style="{ color: dataSource.topFloorFontColor }">
        {{ info.floorName }}
      </div>
      <img class="rightLine" :src="titleLineImg" />
    </div>
    <div class="btns">
      <div
        class="btn"
        v-for="item in info.children"
        :class="{ checked: item.floorId === checkedId }"
        :style="{ color: dataSource.topFloorFontColor }"
        @click="setCheckedId(item.floorId)"
        :key="item.floorId"
      >
        {{ item.floorName }}
      </div>
    </div>
    <div class="goodsArea">
      <div
        class="goodsItem"
        v-for="item in goodsList"
        @click="goDetail(item)"
        :key="item.skuId"
      >
        <div class="center mb-8">
          <el-image
            lazy
            class="goodsImg"
            :id="info.activityId + '-' + item.skuId"
            :fit="'contain'"
            :src="item.fileUrl || goodsDefaultImg"
            alt="商品图片"
            @load="imgLoadHandle"
            @error="imgLoadHandle"
          />
        </div>
        <div class="goodsName ellipsis-2 mb-8">{{ item.skuName }}</div>
        <div class="flex mb-8">
          <label class="label">订货编号：</label>
          <div class="value ellipsis">{{ item.skuCode }}</div>
        </div>
        <div class="flex mb-8">
          <label class="label">商品型号：</label>
          <div class="value ellipsis">{{ item.model }}</div>
        </div>
        <div class="price mb-8">
          <GoodPrice
            :price="+item.sellingPrice || 0"
            :losePrice="+item.originPrice || 0"
            :discountRate="+item.discountRate || 0"
            v-if="!item.isSellingPriceExpire"
          ></GoodPrice>
          <span v-else>待询价</span>
        </div>
        <el-button
          class="buyBtn"
          v-if="item.sellingPrice"
          @click.stop="addCart(item)"
          :loading="loading"
          >立即加购</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import GoodPrice from "@/components/good-price/goodPrice.vue";
import goodsDefaultImg from "@/assets/img/bitmap.png";
import titleLineImg from "@/assets/img/activity/title-line.svg";
import { getAccessToken } from "@/utils/userInfo";
import anime from "animejs"; // 引入
import { formatePrice } from "@/utils/formatePrice";
import { openOther } from "@/utils";

export default {
  components: { GoodPrice },
  props: {
    dataSource: {
      type: Object,
      default: () => {},
    },
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      titleLineImg,
      goodsDefaultImg,
      checkedId: "",
      loading: false,
      page: 1,
      isEnd: false,
      // 通过图片加载计数控制翻页加载
      imgLoadCount: 0,
      goodsList: [],
    };
  },
  mounted() {
    this.checkedId = this.info.children[0].floorId;
    this.getGoodsList();
  },
  methods: {
    // 跳转详情页
    goDetail(goods) {
      const spuId = goods.spuId;
      const skuId = goods.skuId;
      openOther(`goodDetail?spuId=${spuId}&skuId=${skuId}`);
    },
    // 加入购物车
    addCart(goods) {
      // 未登录 跳转登录页
      if (!getAccessToken()) {
        this.$router.push({
          name: "login",
        });
        return false;
      }
      if (this.loading) {
        return false;
      }
      this.loading = true;
      const spuId = goods.spuId;
      const skuId = goods.skuId;
      const custspId = goods.custspId;
      // 购物车类型 ==1
      let shoppingType = "1";
      // 判断是否是企业站用户
      if (this.$store.state.user.corpUserInfo.customerId) {
        // 添加到企业站购物车
        this.$http.post(`/front/oms/crop-site/shopping-cart/add`,{
          custspId: custspId,
          skuId: skuId,
          goodsNum:  1,
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.createDraftAnime(goods, shoppingType)
          this.$message.success('加入购物车成功')
        })
        .finally(() => {
          this.loading = false
        })
        return
      }
      this.$http
        .post(`/front/consumer/shoppingcart/addShoppingCart`, {
          goodsSpuId: spuId,
          goodsSkuId: skuId,
          goodsNum: 1,
          shoppingType: shoppingType,
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false;
          }
          this.$message.success(
            `${this.$t("product.add")} ${this.$t("product.cart")} ${this.$t(
              "product.success"
            )}`
          );
          this.createDraftAnime(goods, shoppingType);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setCheckedId(floorId) {
      this.checkedId = floorId;
      this.initList();
      this.getGoodsList();
    },
    initList() {
      this.page = 1;
      this.imgLoadCount = 0;
    },
    getGoodsList(isInit = true) {
      this.$http
        .post(`/front/cross/commodity-user/activity/topic/commodity/list`, {
          activityId: this.dataSource.activityId,
          floorIds: [this.checkedId],
          limit: 20,
          page: this.page,
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            const { dataList, count } = res.data[0];
            if (isInit) {
              this.goodsList = dataList;
            } else {
              this.goodsList.push(...dataList);
            }

            if (this.goodsList.length >= +count) {
              this.isEnd = true;
            }
          }
        });
    },
    imgLoadHandle() {
      // 通过图片加载记点 来统计加载情况
      this.imgLoadCount += 1;
      // 内容全部加载完成之后 加载下一页
      if (this.imgLoadCount === this.goodsList.length) {
        this.page += 1;
        this.getGoodsList(false);
      }
    },
    // 创建动画效果
    createDraftAnime(item) {
      // shoppingType 固定购物车 = 1
      const fileUrl = item.fileUrl;
      const goodImage = document.getElementById(
        this.info.activityId + "-" + item.skuId
      );
      const cartIcon = document.getElementById("add_cart_nav"); // 获取购物车图标
      // 获取商品图片和购物车的位置
      const startRect = goodImage.getBoundingClientRect();
      const endRect = cartIcon.getBoundingClientRect();

      // 创建飞行元素
      const flyImage = document.createElement("img");
      flyImage.src = fileUrl || goodsDefaultImg;
      flyImage.style.position = "fixed";
      flyImage.style.width = "200px";
      flyImage.style.height = "200px";
      flyImage.style.left = `${startRect.left}px`;
      flyImage.style.top = `${startRect.top}px`;
      flyImage.style.zIndex = 9999;
      document.body.appendChild(flyImage);

      // 使用 anime.js 实现飞行动画
      anime({
        targets: flyImage,
        left: `${endRect.left}px`,
        top: `${endRect.top}px`,
        width: "20px",
        height: "20px",
        duration: 1000,
        easing: "easeInOutQuad",
        complete: () => {
          // 通知购物车
          this.$store.dispatch(
            "setShoppingCartCount",
            this.$store.state.shoppingCartCount + 1
          );

          // 动画完成后移除飞行元素
          document.body.removeChild(flyImage);
        },
      });
    },
    formatePrice,
  },
};
</script>

<style lang="scss" scoped>
.floor {
  font-family: Alibaba PuHuiTi;
}
.titleArea {
  margin-top: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  .title {
    font-family: Alibaba PuHuiTi;
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    margin: 0 24px;
  }
  .rightLine {
    transform: rotate(180deg);
  }
}
.btns {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px;
  .btn {
    padding: 10px 16px;
    margin: 8px;
    cursor: pointer;
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
  }
  .checked {
    border-radius: 400px;
    background: #2a54d1 !important;
    color: #fff !important;
  }
}
.goodsArea {
  display: grid;
  grid-template-columns: repeat(5, minmax(200px, 20%));
  gap: 8px;

  .goodsItem {
    background: #fff;
    border-radius: 16px;
    padding: 8px;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 12px 20px 0px rgba(0, 0, 0, 0.2);
      transform: scale(1.01);
    }
  }
  .goodsImg {
    border-radius: 16px;
    width: 224px;
    height: 224px;
    min-height: 224px;
    object-fit: contain;
  }
  .goodsName {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    font-weight: bold;
    color: #2c2c2c;
    height: 38px;
  }
  .label {
    font-size: 14px;
    color: #666666;
    flex-shrink: 0;
  }
  .value {
    font-family: KAlibabaPuHuiTi;
    font-size: 14px;
    font-weight: bold;
    color: #666666;
    flex: 1;
  }
  .price {
    font-size: 16px;
    font-weight: bold;
    color: #e20e0e;
  }
  .buyBtn {
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    border-width: 1px 0px 0px 0px;
    border-style: solid;
    border-color: #f6f5fa;
    text-align: center;
    font-size: 14px;
    color: #2a54d1;
    cursor: pointer;
    // &:hover {
    //   font-weight: bold;
    // }
  }
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.mb-8 {
  margin-bottom: 8px;
}
.ellipsis-2 {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
